export type PayScheduleBase = {
  id: string;
  name: string;
};

export const PayScheduleFrequencyId = {
  Monthly: 1,
  Fortnightly: 2,
  Weekly: 3,
} as const;

export type PayScheduleFrequencyId =
  (typeof PayScheduleFrequencyId)[keyof typeof PayScheduleFrequencyId];

export type PayScheduleListItem = PayScheduleBase & {
  businessUnitId: string;
  businessUnitName: string | null;
  businessUnitIsActive: boolean;
  companyId: string;
  companyName: string | null;
  countryId: number;
  countryName: string;
  payOccurenceId: number;
  payOccurenceName: string | null;
  frequencyId: PayScheduleFrequencyId;
  frequencyName: string | null;
  isActive: boolean;
  periodEndDaysAfterPeriodStartDate: number;
  paymentDaysAfterPeriodEndDate: number;
  nextPayrunGenerationDate: Date;
  nextPayrunPayDate: Date;
  operatingTimeZoneId: number;
  operatingTimeZoneName: string;
  payrollServiceProviderId: string;
  tags: string[];
};

export type ExternalPayrollConnection = {
  name: string | null;
  externalBusinessUnitName: string | null;
  externalPayScheduleName: string | null;
  externalBusinessUnitId: string | null;
  externalPayScheduleId: string | null;
};

export type PayScheduleDetail = {
  id: string;
  name: string | null;
  businessUnitId: string;
  businessUnitName: string | null;
  firstPayDate: string;
  payrunGenerationDueInDays: string | null;
  payrunGenerationDueTime: string | null;
  amendmentDueInDays: string | null;
  amendmentDueTime: string | null;
  payrunPreparationDueInDays: string | null;
  payrunPreparationDueTime: string | null;
  approvalDueInDays: string | null;
  approvalDueTime: string | null;
  finaliseDueInDays: string | null;
  finaliseDueTime: string | null;
  isUploadBankFile: boolean | null;
  bankFileUploadDueInDays: number | null;
  bankFileUploadDueTime: string | null;
  isBankFileUploadDatePayDay: boolean | null;
  bankFileDateInDays: number | null;
  paymentDueInDays: number | null;
  paymentDueTime: string | null;
  businessNumber: string | null;
  companyId: string;
  companyName: string | null;
  countryId: number | null;
  countryName: string | null;
  frequencyId: number | null;
  frequencyName: string | null;
  payrollModelId: number | null;
  payrollModelName: string | null;
  isActive: boolean;
  payrollSystemConfigurationId: number | null;
  payrollSystemConnectionId: number | null;
  externalPayrollConnection: ExternalPayrollConnection | null;
  reference: string | null;
  isInvoiceNeeded: boolean;
  isProcessed: boolean;
  firstPayCycleStartDate: string;
  tags: string[] | null;
  payrollServiceProviderId: string;
};

export type BasePayMapping = {
  id: number;
  name: string;
};

export type ProcessingFeePayItem = {
  id: number;
  payItemId: number;
  name: string | null;
  checked: boolean;
};

export type ProcessingFeeEmployeeNumberRange = {
  id: number;
  from: number;
  to: number;
  rate: number;
};

export type ProcessingFeeStateRate = {
  id: number;
  stateId: number;
  stateName: string | null;
  rate: number;
};

export type ProcessingFeeExternalPayCategory = {
  id: number;
  externalPayCategoryId: number;
  name: string | null;
  checked: boolean;
};

export type ProcessingFeeExternalExpenseCategory = {
  id: number;
  externalExpenseCategoryId: number;
  name: string | null;
  checked: boolean;
};
export const AmountType = {
  rate: 'Rate',
  percentage: 'Percentage',
} as const;

export type AmountType = (typeof AmountType)[keyof typeof AmountType];

export type PayScheduleProcessingFee = {
  id: number;
  feeOptionId: number;
  feeOption: string | null;
  rateOrPercentage: number;
  amountType: AmountType | null;
  taxFeeId: number;
  taxFeeName: string | null;
  businessUnitId: string | null;
  companyId: string | null;
  invoiceDescription: string | null;
  xeroReferenceCode: string | null;
  isActive: boolean;
  hasStateRate: boolean | null;
  hasBasePay: boolean | null;
  hasPayItems: boolean | null;
  hasPayCategories: boolean | null;
  hasExpenseCategories: boolean | null;
  hasEmployeeRate: boolean | null;
  processingFeePayItems: ProcessingFeePayItem[] | null;
  processingFeeEmployeeNumberRange: ProcessingFeeEmployeeNumberRange[] | null;
  processingFeeStateRate: ProcessingFeeStateRate[] | null;
  processingFeeExternalPayCategory: ProcessingFeeExternalPayCategory[] | null;
  processingFeeExternalExpenseCategory: ProcessingFeeExternalExpenseCategory[] | null;
  payScheduleId: string;
};
